import { useNavigate, Link } from "react-router-dom";
import { DoorClosed, LogOut, Users as UsersIcon, ShieldCheck, Eye, Building2, KeyRound, Wrench, Archive } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="sticky top-0 z-30 bg-slate-900 text-white border-b border-slate-800">
        <div className="max-w-[1600px] mx-auto px-6 h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="nav-home">
            <div className="h-8 w-8 rounded-md bg-emerald-500 flex items-center justify-center">
              <DoorClosed className="h-5 w-5" />
            </div>
            <span className="font-display text-lg font-bold">PuertaCotiza</span>
          </Link>
          <div className="flex items-center gap-4">
            <span className="hidden sm:flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full bg-slate-800">
              {user?.role === "admin"
                ? <><ShieldCheck className="h-3.5 w-3.5 text-emerald-400" /> Administrador</>
                : <><Eye className="h-3.5 w-3.5 text-slate-400" /> Usuario (sin costos)</>}
            </span>
            {user?.role === "admin" && (
              <Link to="/mantenimiento" data-testid="nav-maintenance"
                className="flex items-center gap-1.5 text-sm text-slate-300 hover:text-white transition-colors">
                <Wrench className="h-4 w-4" /> <span className="hidden md:inline">Mantenimiento</span>
              </Link>
            )}
            <Link to="/archivo" data-testid="nav-archive"
              className="flex items-center gap-1.5 text-sm text-slate-300 hover:text-white transition-colors">
              <Archive className="h-4 w-4" /> <span className="hidden md:inline">Archivo</span>
            </Link>
            {user?.role === "admin" && (
              <Link to="/users" data-testid="nav-users"
                className="flex items-center gap-1.5 text-sm text-slate-300 hover:text-white transition-colors">
                <UsersIcon className="h-4 w-4" /> Usuarios
              </Link>
            )}
            {user?.role === "admin" && (
              <Link to="/settings" data-testid="nav-settings"
                className="flex items-center gap-1.5 text-sm text-slate-300 hover:text-white transition-colors">
                <Building2 className="h-4 w-4" /> Empresa
              </Link>
            )}
            <span className="text-sm text-slate-400 hidden md:inline">{user?.name}</span>
            <Link to="/change-password" data-testid="nav-change-password" title="Cambiar contraseña"
              className="flex items-center gap-1.5 text-sm text-slate-300 hover:text-white transition-colors">
              <KeyRound className="h-4 w-4" /> <span className="hidden lg:inline">Contraseña</span>
            </Link>
            <button data-testid="logout-btn" onClick={() => { logout(); nav("/login"); }}
              className="flex items-center gap-1.5 text-sm text-slate-300 hover:text-white transition-colors">
              <LogOut className="h-4 w-4" /> Salir
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-[1600px] mx-auto px-6 py-8">{children}</main>
    </div>
  );
}
